export default __webpack_public_path__ + "static/media/venue__map.329e4c81.png";